/* eslint max-len: 0 */
// Redshift Table Builder & Compiler
// -------
var inherits = require('inherits');

var _require = require('lodash'),
    has = _require.has;

var TableCompiler_PG = require('../../postgres/schema/tablecompiler');

function TableCompiler_Redshift() {
  TableCompiler_PG.apply(this, arguments);
}

inherits(TableCompiler_Redshift, TableCompiler_PG);

TableCompiler_Redshift.prototype.index = function (columns, indexName, indexType) {
  this.client.logger.warn('Redshift does not support the creation of indexes.');
};

TableCompiler_Redshift.prototype.dropIndex = function (columns, indexName) {
  this.client.logger.warn('Redshift does not support the deletion of indexes.');
}; // TODO: have to disable setting not null on columns that already exist...
// Adds the "create" query to the query sequence.


TableCompiler_Redshift.prototype.createQuery = function (columns, ifNot) {
  var createStatement = ifNot ? 'create table if not exists ' : 'create table ';
  var sql = createStatement + this.tableName() + ' (' + columns.sql.join(', ') + ')';
  if (this.single.inherits) sql += " like (".concat(this.formatter.wrap(this.single.inherits), ")");
  this.pushQuery({
    sql: sql,
    bindings: columns.bindings
  });
  var hasComment = has(this.single, 'comment');
  if (hasComment) this.comment(this.single.comment);
};

TableCompiler_Redshift.prototype.primary = function (columns, constraintName) {
  var _this = this;

  var self = this;
  constraintName = constraintName ? self.formatter.wrap(constraintName) : self.formatter.wrap("".concat(this.tableNameRaw, "_pkey"));

  if (columns.constructor !== Array) {
    columns = [columns];
  }

  var thiscolumns = self.grouped.columns;

  if (thiscolumns) {
    var _loop = function _loop(i) {
      var exists = thiscolumns.find(function (tcb) {
        return tcb.grouping === 'columns' && tcb.builder && tcb.builder._method === 'add' && tcb.builder._args && tcb.builder._args.indexOf(columns[i]) > -1;
      });

      if (exists) {
        exists = exists.builder;
      }

      var nullable = !(exists && exists._modifiers && exists._modifiers['nullable'] && exists._modifiers['nullable'][0] === false);

      if (nullable) {
        if (exists) {
          return {
            v: _this.client.logger.warn('Redshift does not allow primary keys to contain nullable columns.')
          };
        } else {
          return {
            v: _this.client.logger.warn('Redshift does not allow primary keys to contain nonexistent columns.')
          };
        }
      }
    };

    for (var i = 0; i < columns.length; i++) {
      var _ret = _loop(i);

      if (typeof _ret === "object") return _ret.v;
    }
  }

  return self.pushQuery("alter table ".concat(self.tableName(), " add constraint ").concat(constraintName, " primary key (").concat(self.formatter.columnize(columns), ")"));
}; // Compiles column add. Redshift can only add one column per ALTER TABLE, so core addColumns doesn't work.  #2545


TableCompiler_Redshift.prototype.addColumns = function (columns, prefix, colCompilers) {
  if (prefix === this.alterColumnsPrefix) {
    TableCompiler_PG.prototype.addColumns.call(this, columns, prefix, colCompilers);
  } else {
    prefix = prefix || this.addColumnsPrefix;
    colCompilers = colCompilers || this.getColumns();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = colCompilers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var col = _step.value;
        var quotedTableName = this.tableName();
        var colCompiled = col.compileColumn();
        this.pushQuery({
          sql: "alter table ".concat(quotedTableName, " ").concat(prefix).concat(colCompiled),
          bindings: []
        });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
};

module.exports = TableCompiler_Redshift;